// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { DateTime } from 'luxon';

export type ChargeFormDateValue = DateTime | null;

export function chargeDateKey(value: ChargeFormDateValue): string | null {
  return value?.toISODate() ?? null;
}
